import React, { useCallback, useState } from "react";
import TaskSidebar from "./Tasksidebar";
import AddProject from "./Add-Project.jsx";
import AddClient from "./Add-Client.jsx";
import AddTask from "./Add-Task.jsx";
import { ProjectModalContext } from "./Service/ProjectModalContext";

const TaskMainLayout = ({ children }) => {
  const [isAddProjectOpen, setAddProjectOpen] = useState(false);
  const [isAddClientOpen, setAddClientOpen] = useState(false);
  const [editProjectDetails, setEditProjectDetails] = useState(null);
  const [editClientDetails, setEditClientDetails] = useState(null);
  const [projectModalSaveCallback, setProjectModalSaveCallback] = useState(null);
  const [clientModalSaveCallback, setClientModalSaveCallback] = useState(null);
  const [isAddTaskOpen, setAddTaskOpen] = useState(false);
  const [editTaskDetails, setEditTaskDetails] = useState(null);
  const [taskModalSaveCallback, setTaskModalSaveCallback] = useState(null);
  const [selectedProject, setSelectedProjectState] = useState(null);
  const [refreshCallback, setRefreshCallback] = useState(null);
  
  const setSelectedProject = useCallback((proj) => {
    setSelectedProjectState(proj);
  }, []);

  const updateSelectedProject = useCallback((partialData) => {
    setSelectedProjectState((prev) => {
      if (!prev) return prev;
      return { ...prev, ...partialData };
    });
  }, []);

  const clearSelectedProject = useCallback(() => {
    setSelectedProjectState(null);
  }, []);

  const closeProjectModals = useCallback(() => {
    setAddProjectOpen(false);
    setAddClientOpen(false);
    setEditProjectDetails(null);
    setEditClientDetails(null);
    setAddTaskOpen(false);
    setEditTaskDetails(null);
  }, []);

  const openAddProject = useCallback((projectDetails = null) => {
    setEditProjectDetails(projectDetails);
    setAddProjectOpen(true);
    setAddClientOpen(false);
  }, []);

  const openAddClient = useCallback((clientDetails = null) => {
    setEditClientDetails(clientDetails);
    setAddClientOpen(true);
    setAddProjectOpen(false);
  }, []);

  const openAddNewTask = useCallback((taskDetails = null) => {
    setEditTaskDetails(taskDetails);
    setAddTaskOpen(true);
    setAddProjectOpen(false);
    setAddClientOpen(false);
  }, []);

  const registerProjectSaveCallback = useCallback((callback) => {
    setProjectModalSaveCallback(() => callback);
  }, []);

  const registerClientSaveCallback = useCallback((callback) => {
    setClientModalSaveCallback(() => callback);
  }, []);

  const registerTaskSaveCallback = useCallback((callback) => {
    setTaskModalSaveCallback(() => callback);
  }, []);

  const handleProjectSave = useCallback(() => {
    if (typeof projectModalSaveCallback === "function") {
      projectModalSaveCallback();
    }
    closeProjectModals();
  }, [closeProjectModals, projectModalSaveCallback]);

  const handleClientSave = useCallback(() => {
    if (typeof clientModalSaveCallback === "function") {
      clientModalSaveCallback();
    }
    closeProjectModals();
  }, [closeProjectModals, clientModalSaveCallback]);

  const handleTaskSave = useCallback(() => {
    if (typeof taskModalSaveCallback === "function") {
      taskModalSaveCallback();
    }
    closeProjectModals();
  }, [closeProjectModals, taskModalSaveCallback]);

  const registerRefreshCallback = useCallback((fn) => {
    setRefreshCallback(() => fn);
  }, []);

  const refreshSelectedProject = useCallback(() => {
    if (typeof refreshCallback === "function") {
      refreshCallback();
    }
  }, [refreshCallback]);

  const contextValue = {
    openAddProject,
    openAddClient,
    openAddNewTask,
    closeProjectModals,
    isAddProjectOpen,
    isAddClientOpen,
    isAddTaskOpen,
    registerProjectSaveCallback,
    registerClientSaveCallback,
    registerTaskSaveCallback,
    selectedProject,
    setSelectedProject,
    updateSelectedProject,
    clearSelectedProject,
    refreshSelectedProject,
    registerRefreshCallback,
  };

  return (
    <ProjectModalContext.Provider value={contextValue}>
      <div className="app-shell">
        <TaskSidebar />
        <div style={{ flex: 1 }} className="app-container-bx">
          {children}
        </div>
      </div>

      <AddProject
        isOpen={isAddProjectOpen}
        onClose={closeProjectModals}
        onSave={handleProjectSave}
        editProjectDetails={editProjectDetails}
      />

      <AddClient
        isOpen={isAddClientOpen}
        onClose={closeProjectModals}
        onSave={handleClientSave}
        editClientDetails={editClientDetails}
      />

      <AddTask
        isOpen={isAddTaskOpen}
        onClose={closeProjectModals}
        onSave={handleTaskSave}
        editTaskDetails={editTaskDetails}
      />
    </ProjectModalContext.Provider>
  );
};

export default TaskMainLayout;